import { defineComponent as _defineComponent } from 'vue';
import { useToasted } from '@/utils/use-toasted';
import { computed } from 'vue';
import { useActions } from 'vuex-composition-helpers';
import { debounce } from 'ts-debounce';
import AICodeField from '@/components/AICodeField.vue';
import QueryExecutionResult from './QueryExecutionResult.vue';
import { useDownloadController } from '@/utils/use-download';
export default /*#__PURE__*/ _defineComponent({
    __name: 'QueryField',
    props: {
        value: null,
        feedId: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const item = computed({
            get() {
                return props.value;
            },
            set(value) {
                emit('input', value);
                //console.log(value);
                debouncedSave();
            },
        });
        const debouncedSave = debounce(saveQuery, 500);
        const { create: createNewQuery, patch: patchQuery, remove } = useActions('query', ['create', 'patch', 'remove']);
        const { create: requestDownload } = useActions('data-export', ['create']);
        const { success, error } = useToasted();
        function saveQuery() {
            patchQuery([item.value._id, item.value, {}])
                .then()
                .catch((errors) => {
                error(errors.message);
            });
        }
        function duplicate(item) {
            const data = {
                name: item.name,
                code: item.code,
                feedId: item.feedId,
                userId: item.userId,
            };
            createNewQuery(data)
                .then(() => {
                success('Query Added');
            })
                .catch((errors) => {
                error(errors.message);
            });
        }
        function removeQuery(item) {
            remove(item._id)
                .then(() => {
                success('Query removed');
            })
                .catch((errors) => {
                error(errors.message);
            });
        }
        const { downloadLargeFile } = useDownloadController();
        async function downloadResults() {
            const { token } = await requestDownload({ queryId: item.value._id });
            const baseURL = process.env.VUE_APP_API_ENDPOINT;
            const url = new URL('/data-export/' + props.value._id, baseURL);
            url.searchParams.set('type', 'csv');
            url.searchParams.set('token', token);
            downloadLargeFile(url.toString());
        }
        function toggleAIFeaturesForThisQuery() {
            let newValue = 'never';
            if (item.value.useAI === 'never') {
                newValue = "forBoth";
            }
            else {
                newValue = "never";
            }
            patchQuery([item.value._id, { useAI: newValue }, {}])
                .then()
                .catch((errors) => {
                error(errors.message);
            });
        }
        const useAIForTitle = computed({
            get: () => item.value.useAI === 'forTitle' || item.value.useAI === 'forBoth',
            set: (value) => {
                let newValue = 'never';
                if (value) {
                    newValue = item.value.useAI === 'forDescription' ? 'forBoth' : 'forTitle';
                }
                else {
                    newValue = item.value.useAI === 'forBoth' ? 'forDescription' : 'never';
                }
                patchQuery([item.value._id, { useAI: newValue }, {}])
                    .then()
                    .catch((errors) => {
                    error(errors.message);
                });
            }
        });
        const useAIForDescription = computed({
            get: () => item.value.useAI === 'forDescription' || item.value.useAI === 'forBoth',
            set: (value) => {
                let newValue = 'never';
                if (value) {
                    newValue = item.value.useAI === 'forTitle' ? 'forBoth' : 'forDescription';
                }
                else {
                    newValue = item.value.useAI === 'forBoth' ? 'forTitle' : 'never';
                }
                patchQuery([item.value._id, { useAI: newValue }, {}])
                    .then()
                    .catch((errors) => {
                    error(errors.message);
                });
            },
        });
        return { __sfc: true, props, emit, item, debouncedSave, createNewQuery, patchQuery, remove, requestDownload, success, error, saveQuery, duplicate, removeQuery, downloadLargeFile, downloadResults, toggleAIFeaturesForThisQuery, useAIForTitle, useAIForDescription, AICodeField, QueryExecutionResult };
    }
});
